<template>
  <a-modal v-model="visible" width="1000px" title="选择需求" @ok="onSubmit" @cancel="close">
    <a-transfer ref="transfer" class="tree-transfer" :list-style="listStyle" :data-source="transferDataSource" show-search :show-select-all="true" :target-keys="targetKeys" :render="item => item.key + ' ' + item.title" @change="handleChange" @search="handleSearch">
      <template slot="children" slot-scope="{ props: { direction, selectedKeys }, on: { itemSelect } }">
        <a-tree
          v-if="direction === 'left'"
          block-node
          :tree-data="treeData"
          show-line
          check-strictly
          :replace-fields="{ title: 'newTitle' }"
          :default-expand-all="true"
          checkable
          :checked-keys="[...selectedKeys, ...targetKeys]"
          @check="
            (keys, props) => {
              onChecked(keys, props, [...selectedKeys, ...targetKeys], itemSelect);
            }
          "
          @select="
            (keys, props) => {
              onChecked(keys, props, [...selectedKeys, ...targetKeys], itemSelect);
            }
          "
        />
      </template>
    </a-transfer>
    <a-pagination v-model="current" style="padding-top: 5px" size="small" :total="total" show-less-items @change="pageChange" />
  </a-modal>
</template>

<script>
import { reviewStoryList } from '@/api/project/review';

function isChecked(selectedKeys, eventKey) {
  return selectedKeys.indexOf(eventKey) !== -1;
}

export default {
  name: 'StorySelector',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    planBindKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      visible: false,
      listStyle: {
        width: '400px',
        height: '400px',
        overflow: 'auto'
      },
      targetKeys: [],
      transferDataSource: [],
      treeData: [],
      current: 1
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
    },
    planBindKeys: {
      immediate: true,
      handler(val) {
        this.targetKeys = val;
        if (val && val.length > 0) {
          reviewStoryList({ story_ids: this.planBindKeys }).then(res => {
            res.data.forEach(item => {
              if (!this.transferDataSource.find(i => i.key === item.key)) {
                this.transferDataSource.push(item);
              }
            });
          });
        }
      }
    },
    data: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          const temp = [];
          const newVal = val.map(item => this.genNewTitle(item));
          this.treeToList(newVal, temp);
          temp.forEach(item => {
            if (!this.transferDataSource.find(i => i.key === item.key)) {
              this.transferDataSource.push(item);
            }
          });
          this.treeData = newVal;
        }
      }
    }
  },
  methods: {
    genNewTitle(node) {
      if (node.children) {
        node.children = node.children.map(child => this.genNewTitle(child));
      }
      return {
        id: node.id,
        key: node.key,
        title: node.title,
        children: node.children,
        newTitle: node.key + ' ' + node.title
      };
    },
    pageChange() {
      this.$emit('change', this.current);
    },
    treeToList(treeDataArr, ret = []) {
      if (treeDataArr) {
        treeDataArr.forEach(item => {
          if (item.children) {
            ret.push(item);
            this.treeToList(item.children, ret);
          } else {
            ret.push(item);
          }
        });
      }
    },
    onChecked(keys, e, checkedKeys, itemSelect) {
      const { eventKey } = e.node;
      itemSelect(eventKey, !isChecked(checkedKeys, eventKey));
    },
    searchTreeNode(value, treeData) {
      for (let i = treeData.length - 1; i >= 0; i--) {
        const item = treeData[i];
        if (!item.title.includes(value)) {
          treeData.splice(i, 1);
        } else if (item.children) {
          this.searchTreeNode(value, item.children);
        }
      }
    },
    close() {
      this.targetKeys = [];
      this.$emit('close');
    },

    handleChange(targetKeys) {
      this.targetKeys = targetKeys;
    },

    handleSearch(dir, value) {
      if (dir === 'left') {
        if (value) {
          this.$emit('search', this.current, value);
        } else {
          this.$emit('search', 1, null);
        }
      }
    },

    onSubmit() {
      this.$emit('close', this.targetKeys);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .tree-transfer .ant-transfer-list:first-child {
  width: 50%;
  flex: none;
}
</style>
